import { RootState } from '@/store/reducers';
import { LiveViewStoreType } from './types';

export const selectLiveVehicleStoreValue = <T extends keyof LiveViewStoreType>(key: T) => ({ 
    liveView 
}: RootState): LiveViewStoreType[T] => liveView[key];

export const selectIsVehicleAutoUpdated = ({ liveView }: RootState) => liveView.autoUpdateVehicleDetails;
export const selectActiveRecord = ({ liveView }: RootState) => liveView.activeRecord;
export const selectVehiclesList = ({ liveView }: RootState) => liveView.vehiclesList;
export const selectMetricPointPlatformsUIds = ({ liveView }: RootState) => liveView.metricPointPlatformsUIds;

